import AboutTemplate from "../components/templates/AboutTemplate";
import { ABOUT_SECTIONS } from "../utils/constants/sections";

const AboutPage = (props) => {
    return (
        <AboutTemplate sections={ABOUT_SECTIONS}/>
    );
}

export default AboutPage;